import { inject, Injectable } from '@angular/core';
import { EncryptionService } from './encryption.service';
import { GtmService } from './google-tag-manager.service';
import { CombinedStore } from 'src/app/core/combined.store';
import { environment } from 'src/environments/environment';

export type GtmTrackedEvent =
  | 'price_view'
  | 'form_devis_submit'
  | 'contract_signature_submit';

@Injectable({
  providedIn: 'root'
})
export class GtmEventServiceService {
  private store = inject(CombinedStore);
  constructor(
    private gtmService: GtmService,
    private encryptionService: EncryptionService,
  ) { }

  async pushEvent(eventName: GtmTrackedEvent): Promise<void> {
    const productName = this.store.path() === "" ? environment.product : this.store.path();
    const offer = productName + '_' + environment.brand;
    const email = this.store.subscriber().email ?? '';
    const hashedEmail = email ? await this.encryptionService.sha256Hex(email) : '';
    const phonePrefix = this.store.subscriber().phone_prefix.phone !== undefined && this.store.subscriber().phone_prefix.phone !== ''
      ? (this.store.subscriber().phone_prefix.indicator?.prefix ?? '') + this.store.subscriber().phone_prefix.phone : '';

    this.gtmService.pushEvent(eventName, {
      user_data_em: hashedEmail,
      user_data_ph: phonePrefix,
      form_name: offer
    });
  }
}
